export const HELP_FILE_ROUTES_MAP = {
    '/pages/product': 'pagesproduct',
    '/pages/addOn': 'pagesaddon',
    '/pages/priceSummary': 'pagespricesummary',
    '/pages/signIn': 'pagessignin',
    '/pages/calendar': 'pagescalendar',
    '/pages/globalBar': 'pagesglobalbar',
    '/pages/filters': 'pagesfilters',
    '/pages/cart': 'pagescart',
    '/pages/guestPayment': 'pagesguestpaymentinformation',
    '/pages/confirmation': 'pagesconfirmation',
    '/pages/hotel': 'pageshotel',
    '/pages/general': 'pagesgeneral',
    '/pages/general/policy-urls': 'Policy_URLs',
    '/pages/hotel/menu-content': 'Hotel_Menu_Content',
    '/manage/manage-configuration': 'Manage_Configuration1',
    '/manage/domains': 'Manage_Domains',
    '/manage/apps': 'Manage_Apps',
    '/manage': 'manage',
    '/theme/colors': 'themecolors',
    '/theme': 'theme',
    '/assets': 'assets',
    '/pages/retailProducts': 'pagesretailproducts',
    '/pages/searchSettings': 'pagessearch',
    '/pages/searchLabels': 'pagessearchlabels',
    '/pages/widgets': 'Widgets',
};

export const HELP_ROUTES = {
    labels: 'labels',
    settings: 'settings',
    icons: 'icons',
    buttons: 'buttons',
    global: 'global',
    header: 'header',
    progressIndicator: 'progressindicator',
    calendar: 'calendar',
    gallery: 'gallery',
    form: 'form',
    customContent: 'customcontent',
    images: 'images',
    customization: 'customization',
    tracking: 'tracking',
    customFonts: 'customfonts',
    other: 'other',
    'tracking-hooks': 'trackinghooks',
    'manage-theme': 'managetheme'
};


export const SEPARATE_HELP_ROUTES = ['menu-content', 'policy-urls', 'manage-configuration', 'domains', 'apps', 'colors', 'searchSettings']


// WEBPACK FOOTER //
// ./src/constants/HelpFile.js